import React from 'react';

import Tiptap from 'App/components/Tiptap/Tiptap';
import asFormField from './asFormField';

export const WysiwygField = asFormField({
    WrappedComponent: React.memo(Tiptap),
    onValidateField: (value, props) => {
        if (props.required && value === '<p></p>') {
            return 'Field is required';
        }
    },
});
